var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CardButtons',{attrs:{"title":"Sugestão","description":"Novas sugestões de carteira","paragraph":"Confira as carteiras sugeridas especialmente para você","action-button-list":_vm.button},on:{"onClick":_vm.open}})
}
var staticRenderFns = []

export { render, staticRenderFns }